import React, { isValidElement, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { GLOBAL_TOOLTIP } from '@/constants/constants';

import Typography from '../typography';
import { ModalHeadingTop } from './modalHeadingTop';

export type ModalHeadingProps = {
  title: ReactNode;
  optionalHeading?: string;
  /** This shows up on the right side of the title with space justtified between */
  rightOfTitleAdornment?: ReactNode;
  /** Classname to apply to the title */
  titleClassName?: string;
  /** ReactNode for the icon */
  icon?: ReactNode;
  iconAndHeading?: boolean;
  onXClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  canClose?: boolean;
  className?: string;
  leftSideButton?: ReactNode;
};

/**
 * A basic modal heading used for our modal components:
 *   - https://www.figma.com/file/Vd7dvy5BLNcY5pDkQ2j0dj/Unified-Design-System-(Working)?node-id=640-6591&t=HAmBvIVr9ABSVnzH-0
 */
const ModalHeading: React.FC<ModalHeadingProps> = ({
  title,
  optionalHeading = undefined,
  rightOfTitleAdornment = undefined,
  icon = undefined,
  iconAndHeading = false,
  onXClick = undefined,
  titleClassName = undefined,
  canClose = true,
  className = undefined,
  leftSideButton = undefined,
}) => {
  return (
    <div className={twMerge('w-full', className)}>
      <ModalHeadingTop
        canClose={canClose}
        icon={icon}
        iconAndHeading={iconAndHeading}
        leftSideButton={leftSideButton}
        optionalHeading={optionalHeading}
        onXClick={onXClick}
      />
      {/* Title */}
      {title &&
        ((typeof title === 'string' && title.length > 0) ||
          isValidElement(title)) && (
          <div
            className="flex justify-between"
            data-tooltip-content={typeof title === 'string' ? title : ''}
            data-tooltip-delay-show={1000}
            data-tooltip-id={GLOBAL_TOOLTIP}
          >
            <Typography
              className={twMerge('truncate', titleClassName)}
              variant="h4"
            >
              {title}
            </Typography>
            {rightOfTitleAdornment}
          </div>
        )}
    </div>
  );
};

export default ModalHeading;
